import React, { useEffect } from 'react';
import * as echarts from 'echarts';
import useECharts from '../../../hooks/useEcharts';

interface ChartProps {
  option: echarts.EChartsOption;
  style?: React.CSSProperties;
  className?: string;
  onChartInit?: (chart: echarts.ECharts) => void;
  renderer?: 'canvas' | 'svg';
  theme?: string;
}

const Chart: React.FC<ChartProps> = ({
  option,
  style = { width: '100%', height: '100%' },
  className,
  onChartInit,
  renderer = 'canvas',
  theme,
}) => {
  // Use our enhanced hook with options
  const { chartRef, chartInstance } = useECharts(option, [], {
    renderer,
    autoResize: true,
    devicePixelRatio: window.devicePixelRatio,
  });

  // Notify parent when chart is initialized
  useEffect(() => {
    if (chartInstance && onChartInit) {
      onChartInit(chartInstance);
    }
  }, [chartInstance, onChartInit]);

  return (
    <div
      ref={chartRef}
      style={{
        ...style,
        // Ensure minimum dimensions
        minHeight: '100px',
        minWidth: '100px',
      }}
      className={className}
    />
  );
};

export default Chart;
